import { render, staticRenderFns } from "./UploadRecord.vue?vue&type=template&id=23385ffa&scoped=true&lang=pug"
import script from "./UploadRecord.vue?vue&type=script&lang=js"
export * from "./UploadRecord.vue?vue&type=script&lang=js"
import style0 from "./UploadRecord.vue?vue&type=style&index=0&id=23385ffa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23385ffa",
  null
  
)

export default component.exports